
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Transcription from '@/store/modules/transcription';
import store from '@/store/store';
import { Component } from 'vue-property-decorator';
import Snackbar from '@/store/modules/snackbar';

const trscModule = getModule(Transcription, store);
const snackbarModule = getModule(Snackbar, store);
@Component
export default class TrscOcr extends Vue {
  get html() {
    if (!trscModule.currentTranscription.ocr)
      return 'この画像のOCRテキストはありません。';
    const notice =
      '<p style="color: red;">※この翻刻文はAIくずし字認識によって自動生成されたテキストです。必ずしも正確な結果ではないことに注意し、翻刻の参考にしてください。<br></p>';
    const text = trscModule.currentTranscription.ocr;
    return (
      notice +
      "<p class='ocr-text'>" +
      text.join('<br>').replaceAll('\n', '<br>') +
      '</p>'
    );
  }

  async copyText() {
    const text = trscModule.currentTranscription.ocr.join('\n');
    if (navigator && navigator.clipboard) {
      await navigator.clipboard.writeText(text);
      snackbarModule.setSnackbar({ msg: '翻刻文をコピーしました' });
      alert('翻刻文をコピーしました');
    }
  }
}
